const exceptionAccountNumbers = [408, 423, 426, 455, 457, 61212];
const regexpExceptionAccountNumber = new RegExp(
    `^(${exceptionAccountNumbers.join('|')})`,
    'gm',
);
/**
 * @description Method Validate card on lune algorithm.
 * @param {string} cardNumber - Number of card.
 * @returns {boolean} Result of validate card.
 */
export const lune = (cardNumber: string): boolean => {
    if (!/^\d+$/.test(cardNumber)) return false;

    const len = cardNumber.length;
    const parity = len % 2;
    let sum = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = len - 1; i >= 0; i--) {
        let d = parseInt(cardNumber.charAt(i), 10);
        if (i % 2 === parity) {
            d *= 2;
        }
        if (d > 9) {
            d -= 9;
        }
        sum += d;
    }
    return sum % 10 === 0;
};

/**
 * @description Method check value is card number.
 * @param {string} value - Checked value.
 * @returns {boolean} Result of check.
 */
export const isCardNumber = (value: string): boolean => {
    const clearValue = value.trim().replace(/\s/g, '');
    const firstNumberOfCard = [2, 3, 4, 5, 6];
    const regexpFirstNumberOfCard = new RegExp(
        `^(${firstNumberOfCard.join('|')})`,
        'gm',
    );

    return Boolean(
        !clearValue.match(regexpExceptionAccountNumber) &&
            clearValue.match(regexpFirstNumberOfCard),
    );
};
